export default {
  edit_note: 'Editar nota',
  add_note: 'Adicionar nota ',
  update: 'Atualizar item',
  feedback: {
    item_sold_out_one: 'Lamentamos, mas {{items}} está atualmente esgotado.',
    item_sold_out_other: 'Lamentamos, mas {{items}} está atualmente esgotado.',
    item_unavailable:
      'Este item só está disponível a partir de {{schedule}}. Por favor, altere a hora da encomenda ou remova o item para encomendar.',
  },
  buttons: {
    update: 'Atualizar',
  },
};
